export default __webpack_public_path__ + "static/media/cnc_mob.b04eab40.jpg";